export default {
  theme: {
    configViewer: {
      baseFontSize: 16,
      typographyExample: 'The quick brown fox jumped over the lazy dog.'
    }
  }
}
